import React from "react";
import { Link } from "react-router-dom";

const AboutHead = () => {
  return (
    <div className="breadcrumbs d-flex align-items-center">
      <div
        className="container position-relative d-flex flex-column align-items-center"
        data-aos="fade"
      >
        <h2>About</h2>
        <ol>
          <li>
            <Link to={"/"}>Home</Link>
          </li>
          <li>About</li>
        </ol>
      </div>
    </div>
  );
};

export default AboutHead;
